import Chart from 'chart.js/auto'
import {TreemapController, TreemapElement} from 'chartjs-chart-treemap';


export default class TreeMapApcCosts {

  constructor(elementId, data) {
    this.elementId = elementId;
    this.publicationData = data

    this.initYearSelector();
    this.initVariantSelector();
    this.initDataset();   
    this.addGraph();
  }

  initYearSelector() {
    this.yearSelector = document.getElementById('apc-year-selector')
    this.selectedYear = this.yearSelector.value

    this.yearSelector.addEventListener('change', (event) => {
      this.selectedYear = event.target.value

      if (this.selectedYear) {
        // Rebuild chart
        this.chart.destroy()

        this.initDataset()
        this.addGraph()
      }
    })
  }

  initVariantSelector() {
    this.variantSelector = document.getElementById('apc-variant-selector')
    this.selectedVariant = this.variantSelector.value
    
    this.variantSelector.addEventListener('change', (event) => {
      this.selectedVariant = event.target.value

      if (this.selectedVariant) {
        // Rebuild chart
        this.chart.destroy()

        this.initDataset()
        this.addGraph()
      }
    })
  }

  initDataset() {
    const publicationCosts = this.publicationData[this.selectedYear]["publicationCosts"]
    this.publicationCostsSorted = {}
    this.publicationCount = this.publicationData[this.selectedYear]["publicationCount"]

    let sortable = []
    for (let [key, value] of Object.entries(publicationCosts)) {
      if (this.selectedVariant == "mean") {
        value = Math.round(value / this.publicationCount[key])
      }
      sortable.push([key, value])
    }

    sortable.sort(function(a, b) {
      return a[1] - b[1];
    }).reverse();

    for (const elem of sortable) {
      this.publicationCostsSorted[elem[0]] = elem[1]
    }
  }

  addGraph() {
    const data = []

    for (const [key, value] of Object.entries(this.publicationCostsSorted)) {
      data.push({"publisher": key, "costs": value, "count": this.publicationCount[key]})
    }

    const dataTree = {
      datasets: [
        {
          labels: {
            color: '#000',
            display: true,
            font: {size: 18},
            formatter: (ctx) => this.getLabel(ctx, data),
            overflow: 'fit',
          },
          tree: data,
          key: 'costs',
          borderColor: 'rgba(93, 135, 54, 1.0)',
          borderWidth: 1,
          spacing: 1,
          backgroundColor: (ctx) => this.getBackgroundColor(ctx),
        }
      ],
      options: {
        display: true
      }
    };

    this.chart = new Chart(
      document.getElementById(this.elementId),
      {
        type: 'treemap',
        data: dataTree,
        options: {
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              callbacks: {
                title(items) {
                  const dataItem = items[0].raw;
                  return dataItem._data["publisher"];
                }
              }
            }
          }
        },
      }
    );
  }

  getBackgroundColor(ctx) {
    const red = 243
    const green = 198
    const blue = 35
    const alpha = (100 - (ctx.dataIndex * 10)) / 100;
    return `rgba(${red}, ${green}, ${blue}, ${alpha})`
  }

  getLabel(ctx, data) {
    const i = ctx.dataIndex;
    return `${data[i].publisher} (${data[i].count}): ${data[i].costs} €`
  }
}
